(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('custactPlan', {
        templateUrl: 'views/components/views/custactPlan/custactPlan.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'custactPlanService', function ($stateParams, stateService, custactPlanService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let custactPlanKeyno = $stateParams.custactplan_keyno;
            
            vm.model = {
                readyPlanNote: true,
                videoUrlButtons: [
                    { id: 'goto', icon: 'fas fa-video', color: 'primary', type: 'primary', onClick: () => window.open(vm.model.edit.video_url) }
                ],
                edit: {},
                lockedSave: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region LOAD PROCEDURE FUNCTION CALL

            async function loadEdit() {
                vm.model.edit = (await custactPlanService.getEdit({ custactplan_keyno: custactPlanKeyno }))[0];
            }

            // #endregion LOAD PROCEDURE FUNCTION CALL

            // #region MULTI DIRECTION BUTTON FUNCTIONS

            vm.goToFunc = function (state, e) {
                switch (state) {
                    case 'workDetails':
                        if (e?.ctrlKey) {
                            stateService.newTab(vm.model.edit.item_state, vm.model.edit.item_parms);
                        } else {
                            stateService.go(vm.model.edit.item_state, vm.model.edit.item_parms);
                        }
                        break;
                    default:
                        break;
                }
            };

            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

            vm.saveChanges = function () {
                vm.model.lockedSave = true;

                custactPlanService.saveObj(vm.model.edit).then(() => {
                    vm.model.lockedSave = false;
                    stateService.back();
                }, vm.model.lockedSave = false);
            }

            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

            // #region ON INIT FUNCTION

            vm.$onInit = async function () {
                loadEdit();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
